/*
 * @Author: huangyh
 * @Date: 2021-03-12 11:31:43
 * @LastEditors: huangyh
 * @LastEditTime: 2021-03-31 10:11:22
 */
import QuestionnaireList from '@/pages/questionnaire/questionnaireList/index'
import QuestionInfo from '@/pages/questionnaire/questionnaireList/info'
import QuestionnaireStatistics from '@/pages/questionnaire/questionnaireStatistics/index'

export default [
  {
    path: '/questionnaireList',
    name: 'QuestionnaireList',
    component: QuestionnaireList,
    meta: { name: '问卷列表', keepAlive: true }
  },
  {
    path: '/questionInfo',
    name: 'QuestionInfo',
    component: QuestionInfo,
    meta: { name: '问卷信息', keepAlive: true }
  },
  {
    path: '/questionnaireStatistics',
    name: 'QuestionnaireStatistics',
    component: QuestionnaireStatistics,
    meta: { name: '数据报表', keepAlive: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/questionnaire/qnList.js